import React from 'react'
import PropTypes from 'prop-types'

const clampProgress = (value) => Math.min(100, Math.max(0, value ?? 0))

const ProgressBar = ({ progress }) => {
  const clampedProgress = clampProgress(progress)

  return (
    <div className="progress-bar-container media-list-item__progress">
      <div className="progress-bar">
        <div
          className="progress-bar__fill"
          style={{ width: `${clampedProgress}%` }}
        />
      </div>
    </div>
  )
}

export default ProgressBar

ProgressBar.propTypes = {
  progress: PropTypes.number,
}

ProgressBar.defaultProps = {
  progress: 0,
}